// Copyright (c) Microsoft. All rights reserved.

import { Caption1, Card, CardHeader, Text, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import { customTokens, SharedStyles } from '../../../styles';
import { getFileIconByFileExtension } from '../tabs/DocumentsTab';

const useClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.margin(tokens.spacingVerticalS, 0, 0, 0),
    },
    card: {
        height: 'fit-content',
        width: '400px',
        backgroundColor: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        borderRadius: '10px',
        transition: 'all 0.2s ease',
        ...shorthands.gap(0),
        ...shorthands.padding(
            tokens.spacingVerticalS,
            tokens.spacingHorizontalXXXL,
            tokens.spacingHorizontalS,
            tokens.spacingHorizontalS,
        ),
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.25)',
            border: '1px solid rgba(255,255,255,0.5)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
        },
    },
    cardCaption: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '18px',
        color: 'rgba(255,255,255,0.7)',
    },
    cardHeader: {
        ...shorthands.margin(0, tokens.spacingHorizontalS),
    },
    cardHeaderText: {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '18px',
        color: tokens.colorNeutralForegroundStaticInverted,
    },
    cardHeaderTextContainer: {
        ...SharedStyles.overflowEllipsis,
    },
    footer: {
        float: 'right',
        fontSize: 'small',
        fontWeight: '500',
        color: tokens.colorNeutralForegroundDisabled,
    },
    icon: {
        height: '24px',
        width: '24px',
        color: customTokens.colorMeBackground,
        backgroundColor: customTokens.colorRedBackground,
        padding: tokens.spacingVerticalS,
        borderRadius: tokens.borderRadiusMedium,
    },
    floatLeft: {
        float: 'left',
    },
});

interface ChatHistoryDocumentContentProps {
    isMe: boolean;
    message: IChatMessage;
}

interface DocumentData {
    name: string;
    size: string;
    isUploaded: boolean;
}

interface DocumentMessageContent {
    documents: DocumentData[];
}

export const ChatHistoryDocumentContent: React.FC<ChatHistoryDocumentContentProps> = ({ message }) => {
    const classes = useClasses();

    let documents: DocumentData[] = [];
    try {
        ({ documents } = JSON.parse(message.content) as DocumentMessageContent);
    } catch (e) {
        console.error('Error parsing chat history file item: ' + message.content);
    }

    return (
        <>
            {documents.map(({ name }, index) => (
                <div className={classes.root} key={`${message.id ?? 'unknown-message-id'}-document-${index}`}>
                    <Card appearance="filled-alternative" className={classes.card}>
                        <CardHeader
                            className={classes.cardHeader}
                            image={getFileIconByFileExtension(name, { className: classes.icon })}
                            header={{
                                className: classes.cardHeaderTextContainer,
                                children: (
                                    <Text className={classes.cardHeaderText} title={name}>
                                        {name}
                                    </Text>
                                ),
                            }}
                            description={
                                //eger yuklenen dosya belge ise belge yazacak png vs ise hicbir sey yazmayacak!
                                <Caption1 block className={classes.cardCaption}>
                                    Belge
                                </Caption1>
                            }
                        />
                        {/*                         <ProgressBar thickness="large" color={isUploaded ? 'success' : 'error'} value={1} />
                         */}{' '}
                    </Card>
                    {/* <span className={isMe ? classes.footer : mergeClasses(classes.footer, classes.floatLeft)}>
                        {isUploaded ? 'Success: memory established' : 'Failed: memory not established'}
                    </span> */}
                </div>
            ))}
        </>
    );
};
